var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g, _g2, _g3, _g4, _path67, _g5, _g6, _path68, _path69, _path70, _g7, _path71, _g8, _g9, _g0, _g1, _g10, _g11, _path72;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 296.76 689.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02,678.56c12.8-10.94,25.55-23.13,38-42,36.27-53.56,42.55-121.85,69.56-222.67,13.2-49.26,28.08-69.16,50.67-138.67,20.67-63.61,48.67-115.89,55.78-230.28",
    fill: "none",
    stroke: "#7db5a9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.91,618.22c-15.78,4.22-32.67,14-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8,597.78c5.56,12.89,8.22,32.67,2,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.91,545.33c-13.78,6.44-31.78,19.11-40.89,32.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.68,486.11c-14.06,4.89-37.44,25-45.39,39.39",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.24,419.22c-15.11,4.44-42.77,30.02-50.89,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.71,325.93c6.22,13.11,12.44,38,13.33,56.44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.38,418.38c7.76,11.69,20.15,44.64,19.56,64.44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.13,501.11c6.89,22.22,20.67,40.22,17.78,70",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M55.57,630.11c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.68,627.33c-17.22-15.94-24.89-42.72-16.78-75.39,22.78,26.67,26.11,54.56,16.78,75.39Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.46,558.33c30.47,3.78,47.78-15.56,54.67-33.33-26.67.67-43.56,10.67-54.67,33.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.71,312.38c-14.17.83-46.56,18.56-55.67,32.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M208.78,226.09c-14.94,7.73-35.89,25.23-44.74,36.62",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05,321.21c32.83,8.83,52.61-4.72,59.5-22.5-25.83-2.17-48.39-.17-59.5,22.5Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-197.95,407.04c-15.51,7.89-36.37,25-39.76,34.92",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-218.55,420.73c24.93,1.87,45.07-20.23,47.6-34.02-18.96,1.99-42.69,16.12-47.6,34.02Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-555.71,382.92c19.32-15.86,18.64-45.75,10.95-57.47-12.34,14.53-19.76,41.13-10.95,57.47Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-537.21,418.31c-11.9,7.87-27.3,23.76-29.14,32.16",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-552.72,431.37c20.49-.8,34.84-20.68,35.61-32.15-15.26,3.39-33.28,17.11-35.61,32.15Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-170.62,325.71c-15.51,7.89-36.37,25-39.76,34.92",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-191.22,339.39c24.93,1.87,45.07-20.23,47.6-34.02-18.96,1.99-42.69,16.12-47.6,34.02Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-162.86,243.72c-10.25,9.46-22.64,27.19-23.1,35.59",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-175.78,258.75c19.65-3.98,30.39-25.4,29.35-36.59-14.2,5.65-29.44,21.71-29.35,36.59Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M241.19,124.69c-12.66,3.81-34.81,21.26-41.14,32.69",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M223.03,135.2c24.47,6.87,40.37-10.6,43.64-26.31-20.67,2.02-38.16,6.84-43.64,26.31Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M234.98,77.32c-7.61,5.64-21.6,24.39-24.43,33.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M224.42,91.26c21.58-7.05,29.1-25.6,26.46-38.05-15.23,8.22-28.52,21.32-26.46,38.05Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.68,530.67c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M142.47,248.91c5.16,16.64,9.49,32.4,7.33,54.7",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M189.28,93.43c6.39,14.63,12.85,34.79,10.29,57.74",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M166.71,178.6c6.39,14.63,12.09,29.62,9.53,52.57",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.46,273.39c-17.23-12.98-22.66-44.25-18.67-62.22,22.97,22.72,23.16,47.49,18.67,62.22Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M-356.73,683.49c12.8-10.94,35.64-27.17,48.08-46.04,36.27-53.56,47.76-118.56,76.25-218.96,14-49.33,60-118,47.01-198.91",
    fill: "none",
    stroke: "#7db5a9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M-710.19,683.59c79.1-41.85,121.4-149.58,142.42-232.27,7.44-30.33,12.86-61.2,15.43-92.31.08-.96.92-1.67,1.87-1.59.96.08,1.67.91,1.59,1.87-2.46,31.35-7.78,62.41-15.15,92.95-21.01,84.13-63.5,192.97-143.9,235.81-2.91,1.38-5.26-2.79-2.26-4.46h0Z",
    fill: "#7db5a9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M-264.76,619.11c-16.58,3.6-33.31,13.5-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M-323.4,608.82c2.92,13.43,6.04,26.04,0,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M-238.76,546.22c-13.78,6.44-31.78,19.11-40.89,32.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M-212.51,481.6c-12.12.62-39.86,29.64-48.44,44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-615.87,506.44c6.89,22.22,16.11,23.33,13.22,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-240.54,358c6.89,22.22,14.03,24.04,11.14,53.82",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M-206.2,284.33c6.89,22.22,8.36,24.71,5.47,54.49",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M-293.09,631c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33h0Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M-593.2,601.78c-16.58,3.6-33.31,13.5-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M-621.54,613.67c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M-966.96,618.67c-15.96,3.46-32.07,12.99-45.14,22.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-994.23,630.11c29.34,3.64,50.74-6.79,62.46-28.24-25.57-3.5-47.39,6.32-62.46,28.24Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M-320.06,636.15c-16.52-24.24-22.51-38.78-12.93-68.81,20.91,27.09,23.04,48.96,12.93,68.81Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M-651.4,591.93c2.92,13.43,6.04,26.04,0,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M-648.06,619.27c-16.52-24.24-22.51-38.78-12.93-68.81,20.91,27.09,23.04,48.96,12.93,68.81Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-1020.82,615.16c2.23,10.26,4.61,19.89,0,34.64",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M-1018.27,636.04c-12.62-18.52-17.2-29.63-9.88-52.57,15.97,20.7,17.6,37.41,9.88,52.57Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M-260.2,559.22c30.47,3.78,47.78-15.56,54.67-33.33-26.67.67-43.56,10.67-54.67,33.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-556.99,506.86c-13.29,7.39-30.36,21.29-38.49,35.67",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M-577.47,521.33c30.66,1.64,46.57-18.86,52.2-37.07-26.55,2.53-42.7,13.68-52.2,37.07Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M-983.84,593.29c25.4-17.26,25.65-43.21,19.1-61.11-19.6,18.09-25.7,36.75-19.1,61.11Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M-604.32,536c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M-294.54,534c6.89,22.22,16.11,23.33,13.22,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M-282.98,563.56c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M-270.27,462.04c5.97,12.06,13.12,21.51,14.2,38.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M-275.6,412.26c5.94,7.86,17.76,29.34,16.43,54.23",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M-243.93,306.26c5.94,7.86,12.96,32.26,14.09,56.01",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M-260.96,477.86c-14.72-7.79-23.58-26.48-22.74-40.67,20.3,14.51,24.36,28.89,22.74,40.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M-233.07,378.04c-17.43-6.7-25.04-32.63-21.63-47.86,24.09,15.19,26.07,36.58,21.63,47.86Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M-582.67,432.03c4.39,22.85,11.29,25.45,5.13,54.72",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M-577.45,452.78c-16.58-8.59-21.28-35.2-16.21-49.96,22.27,17.76,21.87,39.24,16.21,49.96Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M-201.41,303.42c-14.04-8.37-17.84-33.59-13.43-47.46,18.8,17.12,18.32,37.41,13.43,47.46Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M144.23,422.54",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.37,379.9",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.96,406.61l-1.67-25.67c-12.5-16.5-32.83-.17-22.17,13.83l23.83,11.83h.01Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.15,407.1l21.39-14.28c8.04-19.08-16.27-28.52-23.06-12.28l1.67,26.56h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6,419.78",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.65,406.95l23.08,11.36c20.54-2.6,16.52-28.37-.93-26.11l-22.14,14.75h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.14,406.87l1.7,25.66c12.52,16.48,32.83.12,22.15-13.86l-23.85-11.8Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.63,407.02l-21.46,14.18c-8.13,19.04,16.14,28.59,23.01,12.39l-1.55-26.56h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.96,406.61l-23.01-11.5c-20.55,2.48-16.69,28.27.78,26.12l22.23-14.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 165.3,
    y1: 406.72,
    x2: 152.07,
    y2: 408.28,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.37,407.36l-13.01,3.32c-3.58.72-4.22-4.67-.56-4.8l13.43.21c.74,0,.87,1.1.15,1.27h-.01Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 166.74,
    y1: 405.39,
    x2: 158.8,
    y2: 395.01,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.23,405.78l-9.35-9.3c-2.47-2.69,1.88-6.03,3.84-2.93l6.53,11.45c.38.63-.52,1.31-1.02.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 166.63,
    y1: 405.83,
    x2: 161.25,
    y2: 420.13,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,406.06l-3.72,14.92c-1.03,3.43-6.01,1.56-4.52-1.7l7.04-13.67c.34-.67,1.39-.27,1.2.45h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 167.52,
    y1: 407.17,
    x2: 176.91,
    y2: 419.35,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.02,406.78l10.8,11.1c2.38,2.66-1.85,5.94-3.82,2.95l-7.99-13.27c-.39-.64.5-1.32,1.01-.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 167.63,
    y1: 405.28,
    x2: 174.58,
    y2: 393.9,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08,404.94l5.44-12.3c1.64-3.26,6.27-.43,4.12,2.52l-8.47,10.45c-.45.58-1.41,0-1.09-.67h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 169.52,
    y1: 406.17,
    x2: 182.41,
    y2: 406.72,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.54,405.53l12.97-1.22c3.66-.16,3.43,5.3-.21,4.82l-12.81-2.33c-.73-.12-.68-1.22.06-1.28h-.01Z",
    fill: "#7db5a9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.98,184.79",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.57,211.5l-1.67-25.67c-12.5-16.5-32.83-.17-22.17,13.83l23.83,11.83h.01Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.76,211.99l21.39-14.28c8.04-19.08-16.27-28.52-23.06-12.28l1.67,26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.21,224.67",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.27,211.84l23.08,11.36c20.54-2.6,16.52-28.37-.93-26.11l-22.14,14.75h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.75,211.76l1.7,25.66c12.52,16.48,32.83.12,22.15-13.86l-23.85-11.8h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.24,211.91l-21.46,14.18c-8.13,19.04,16.14,28.59,23.01,12.39l-1.55-26.56h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.57,211.5l-23.01-11.5c-20.55,2.48-16.69,28.27.78,26.12l22.23-14.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 228.91,
    y1: 211.61,
    x2: 215.68,
    y2: 213.17,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.98,212.25l-13.01,3.32c-3.58.72-4.22-4.67-.56-4.8l13.43.21c.74,0,.87,1.1.15,1.27h-.01Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 230.35,
    y1: 210.28,
    x2: 222.41,
    y2: 199.9,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.84,210.67l-9.35-9.3c-2.47-2.69,1.88-6.03,3.84-2.93l6.53,11.45c.38.63-.52,1.31-1.02.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 230.24,
    y1: 210.72,
    x2: 224.86,
    y2: 225.01,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.84,210.95l-3.72,14.92c-1.03,3.43-6.01,1.56-4.52-1.7l7.04-13.67c.34-.67,1.39-.27,1.2.45h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 231.13,
    y1: 212.06,
    x2: 240.52,
    y2: 224.24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.63,211.67l10.8,11.1c2.38,2.66-1.85,5.94-3.82,2.95l-7.99-13.27c-.39-.64.5-1.32,1.01-.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 231.24,
    y1: 210.17,
    x2: 238.19,
    y2: 198.79,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.69,209.83l5.44-12.3c1.64-3.26,6.27-.43,4.12,2.52l-8.47,10.45c-.45.58-1.41,0-1.09-.67h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 233.13,
    y1: 211.06,
    x2: 246.02,
    y2: 211.61,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.16,210.42l12.97-1.22c3.66-.16,3.43,5.3-.21,4.82l-12.81-2.33c-.73-.12-.68-1.22.06-1.28h-.01Z",
    fill: "#7db5a9"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.17,126.19",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,150.67l-6.24-23.5c-14.61-13.02-30.49,5.85-18.03,16.88l24.27,6.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.79,151.09l17.24-17.15c3.97-19.16-20.31-23.48-23.64-7.18l6.4,24.33Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.71,158.2",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.16,150.67l23.48,6.32c18.57-6.17,10.14-29.34-5.64-24.05l-17.84,17.73h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.66,150.69l6.27,23.5c14.63,13,30.48-5.89,18.01-16.91l-24.28-6.59Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29,151.11l-17.32,17.07c-4.06,19.15,20.2,23.57,23.6,7.29l-6.29-24.36h.01Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,150.67l-23.44-6.46c-18.61,6.06-10.32,29.28,5.49,24.09l17.95-17.63Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 148,
    y1: 151.08,
    x2: 136.02,
    y2: 154.93,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.2,151.68l-11.44,5.55c-3.39,1.43-5.07-3.78-1.48-4.6l12.53-2.17c.72-.13,1.05.91.39,1.22h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 149.1,
    y1: 149.57,
    x2: 139.84,
    y2: 141.4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.67,150.05l-10.43-6.84c-2.98-2.18.66-6.31,3.2-3.62l8.08,9.5c.49.54-.26,1.37-.85.96h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 149.07,
    y1: 150.01,
    x2: 146.69,
    y2: 164.25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.71,150.11l-.63,14.53c-.33,3.59-5.62,2.72-4.76-.8l4.13-13.95c.21-.72,1.3-.53,1.26.21h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 150.14,
    y1: 151.08,
    x2: 161.08,
    y2: 160.66,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56,150.6l12.11,8.25c2.89,2.15-.66,6.21-3.18,3.63l-9.77-10.92c-.51-.54.25-1.39.84-.96h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 149.9,
    y1: 149.31,
    x2: 154.27,
    y2: 137.49,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.3,149.09l2.7-12.44c.96-3.55,6.11-1.65,4.53,1.67l-6.03,11.21c-.34.65-1.36.27-1.2-.44h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 151.82,
    y1: 149.79,
    x2: 163.87,
    y2: 147.95,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.72,149.16l11.79-3.59c3.59-.89,4.42,4.55.73,4.77l-12.33.09c-.73.01-.89-1.06-.19-1.26h0Z",
    fill: "#7db5a9"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.53,271.21",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.84,296.64l-8.12-24.41c-16.27-12.79-31.8,8.16-17.94,19l26.05,5.41h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.15,297.07l17.08-19.23c2.94-20.49-22.97-23.46-25.42-6.03l8.35,25.27h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.98,302.88",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.57,296.54l25.2,5.14c19.2-7.73,8.79-31.64-7.52-25.02l-17.68,19.89h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.04,296.59l8.15,24.39c16.29,12.77,31.79-8.21,17.91-19.03l-26.06-5.37h0Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.63,297.12l-17.17,19.16c-3.04,20.48,22.86,23.57,25.39,6.15l-8.23-25.3h.01Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.84,296.64l-25.17-5.29c-19.25,7.61-8.98,31.58,7.37,25.07l17.8-19.78Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 82.26,
    y1: 297.17,
    x2: 69.86,
    y2: 302.03,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.49,297.77l-11.75,6.51c-3.28,1.61-5.26-3.45-1.76-4.5l13.04-3.2c.72-.18,1.12.84.47,1.19h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 83.32,
    y1: 295.52,
    x2: 73.01,
    y2: 287.49,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.93,296.02l-11.4-6.62c-3.07-1.99.27-6.3,2.97-3.81l9.22,9.42c.53.51-.17,1.39-.79,1.01h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 83.32,
    y1: 295.98,
    x2: 81.74,
    y2: 311.17,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.96,296.04l.18,15.37c-.13,3.58-5.42,3.04-4.8-.5l3.35-15.01c.16-.73,1.27-.62,1.27.13h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 84.52,
    y1: 297.04,
    x2: 96.7,
    y2: 306.44,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.91,296.53l13.26,8c2.98,1.99-.27,6.2-2.95,3.82l-11.09-10.81c-.55-.51.16-1.41.78-1.01h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 84.15,
    y1: 295.19,
    x2: 87.99,
    y2: 282.42,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.54,295l2.14-13.28c.76-3.57,5.96-2.01,4.62,1.39l-5.54,12.25c-.3.68-1.35.36-1.22-.37h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 86.2,
    y1: 295.57,
    x2: 98.81,
    y2: 292.84,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.07,294.94l12.23-4.46c3.5-1.08,4.66,4.25,1.02,4.72l-12.98.99c-.73.06-.96-1.01-.27-1.25h0Z",
    fill: "#7db5a9"
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M201.05,375.38c4.21,1.19,14.98-13.68,13.86-25.79-.12-1.3-1.57-2.1-2.85-2.09-7.35.04-16.44,7.9-22.67,14.88",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M139.3,488.21c3.65,4.28,20.08-2.13,24.3-16.08.37-1.21-.66-2.35-1.75-2.97-7.23-4.16-20.88-.89-28.05,5.22",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 128.68,
    y1: 486.11,
    x2: 147.13,
    y2: 478.06,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.48,485.65c4.27-5.26,11.62-8.82,18.44-8.06.32.05.54.35.5.67-3.64,5.64-11.99,8.8-18.54,8.3-.43-.04-.67-.58-.4-.92h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 127.9,
    y1: 485.98,
    x2: 143.82,
    y2: 465.89,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.51,485.67c.72-8.81,7.2-17.77,15.92-20.1.34-.08.68.13.77.47-.08,8.99-7.53,17.58-15.9,20.25-.4.12-.81-.21-.78-.62h-.01Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 128.22,
    y1: 487.31,
    x2: 154.27,
    y2: 489.82,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.26,486.81c7.99-3.51,19.02-2.88,26.06,2.51.26.21.3.59.09.84-7.65,4.22-19.25,2.57-26.25-2.36-.35-.25-.29-.82.1-1h0Z",
    fill: "#7db5a9"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-204.23,481.64c3.65,4.28,20.08-2.13,24.3-16.08.37-1.21-.66-2.35-1.75-2.97-7.23-4.16-20.88-.89-28.05,5.22",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -214.84,
    y1: 479.54,
    x2: -196.4,
    y2: 471.49,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-215.04,479.08c4.27-5.26,11.62-8.82,18.44-8.06.32.05.54.35.5.67-3.64,5.64-11.99,8.8-18.54,8.3-.43-.04-.67-.58-.4-.92h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -215.62,
    y1: 479.41,
    x2: -199.7,
    y2: 459.32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-216.01,479.1c.72-8.81,7.2-17.77,15.92-20.1.34-.08.68.13.77.47-.08,8.99-7.53,17.58-15.9,20.25-.4.12-.81-.21-.78-.62h-.01Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -215.31,
    y1: 480.74,
    x2: -189.25,
    y2: 483.26,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-215.26,480.25c7.99-3.51,19.02-2.88,26.06,2.51.26.21.3.59.09.84-7.65,4.22-19.25,2.57-26.25-2.36-.35-.25-.29-.82.1-1h0Z",
    fill: "#7db5a9"
  })))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77,377.08c1.83-6.66,7.22-13.11,13.86-15.34.31-.09.64.08.73.39-1.04,6.7-7.62,13.3-13.85,15.62-.41.15-.85-.25-.74-.67h0Z",
    fill: "#7db5a9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M186.88,377.5c-2.87-8.58-.52-19.78,6.54-25.72.27-.22.66-.17.88.1,2.82,6.83,1.24,13.92-1.99,20.16-.31.65-4.55,7.43-5.44,5.46h0Z",
    fill: "#7db5a9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M188.04,378.28c5.99-6.5,16.56-10.5,25.31-8.48.32.08.51.41.43.72-5.37,7.01-16.91,10.31-25.42,8.7-.42-.08-.6-.63-.32-.95h0Z",
    fill: "#7db5a9"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.27,397.93",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,367.71c-3.11,9.7-2.96,20,.44,30.89,3.16.53,6.57,1.95,10.22,4.22l1.67-9.78c2.09.96,4.51,2.98,7.11,5.56,1.76-1.18,3-6.12,4.22-11.22-5.83-8.43-13.51-15.17-23.67-19.67h.01Z",
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.27,397.93c11.92,1.55,17.92,6.82,28.89,20.17.08.09,0,.24-.12.22-9.87-1.49-21.96-9.19-28.77-20.4h0Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.16,401.27c.38-7.1,1.56-13.08,4.44-16.67,5.92,9.35,4.73,20.75.02,33.15-.05.13-.24.1-.25-.04-.15-9.92-3.65-18.49-13.11-24.66-1.29,3.14-1.47,6.78-1.11,10.67",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.27,398.6c-2.56-11.01-3.04-22.09-.11-30.89,8.4,2.24,18.36,10.03,24.22,18.83",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M181.71,292.88c-5.3,6.33-25,16.17-32.83,17",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M191.73,291.65c5.04,2.51,17.64-9.84,16.05-24.33-.14-1.25-1.52-1.9-2.78-2.05-8.29-.99-19.55,7.37-23.76,15.81",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 181.15,
    y1: 293.88,
    x2: 194.95,
    y2: 279.24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.79,293.54c1.86-6.51,7.22-12.67,13.8-14.65.32-.08.64.11.72.42-1.11,6.58-7.61,12.82-13.8,14.91-.41.14-.84-.27-.73-.69h.01Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 180.38,
    y1: 294.07,
    x2: 187.14,
    y2: 269.34,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,293.94c-2.79-8.38-.35-19.17,6.75-24.73.28-.21.68-.15.89.13,3.45,8.35-.01,19.08-6.68,24.87-.32.27-.83.13-.96-.26h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 181.19,
    y1: 295.17,
    x2: 206.15,
    y2: 287.26,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.04,294.7c5.93-6.35,16.41-10.12,24.96-7.91.32.09.5.42.41.74-5.38,6.88-16.69,9.91-25.07,8.13-.42-.09-.59-.64-.3-.95h0Z",
    fill: "#7db5a9"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.6,82.41c4.37-3.75-2.27-20.51-16.56-24.75-1.24-.37-2.4.68-3.04,1.8-4.23,7.41-.82,21.33,5.46,28.64",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 188.5,
    y1: 93.26,
    x2: 180.18,
    y2: 74.45,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05,93.46c-5.34-4.38-9-11.83-8.32-18.8.04-.32.34-.55.66-.5,5.7,3.68,9,12.27,8.58,18.9-.03.44-.57.67-.91.4h-.01Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 188.38,
    y1: 94.05,
    x2: 167.75,
    y2: 77.89,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.07,94.45c-8.92-.77-18.14-7.37-20.63-16.17-.09-.34.11-.68.45-.77,9.14.12,17.94,7.68,20.8,16.15.13.4-.2.82-.62.79h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 189.73,
    y1: 93.73,
    x2: 192.19,
    y2: 67.1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.24,93.68c-3.53-8.12-2.92-19.42,2.46-26.63.2-.26.58-.3.84-.1,4.25,7.76,2.61,19.67-2.3,26.83-.25.35-.82.3-1-.09h0Z",
    fill: "#7db5a9"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-240.97,299.5c4.93-2.98,1.17-20.6-12.22-27.16-1.16-.57-2.48.27-3.29,1.27-5.4,6.61-4.35,20.9.63,29.15",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -244.85,
    y1: 309.85,
    x2: -249.93,
    y2: 289.92,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245.33,309.97c-4.54-5.2-6.91-13.16-5.09-19.93.1-.31.42-.48.73-.39,5.01,4.58,6.83,13.59,5.32,20.07-.1.43-.68.57-.97.25h.01Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -245.1,
    y1: 310.61,
    x2: -262.76,
    y2: 291.24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245.47,310.95c-8.67-2.24-16.66-10.28-17.66-19.37-.03-.35.23-.65.57-.68,7.2,1.35,12.19,6.49,15.57,12.56.37.61,3.64,7.84,1.52,7.48h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -243.71,
    y1: 310.52,
    x2: -236.87,
    y2: 284.66,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-244.19,310.39c-2.13-8.6.35-19.64,6.84-25.86.24-.22.62-.2.84.04,2.33,6.9.47,13.98-2.55,20.26-.34.66-4.28,7.64-5.13,5.56h0Z",
    fill: "#7db5a9"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-273.73,405.15c4.37-3.75-2.27-20.51-16.56-24.75-1.24-.37-2.4.68-3.04,1.8-4.23,7.41-.82,21.33,5.46,28.64",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -275.83,
    y1: 416.01,
    x2: -284.15,
    y2: 397.2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-276.29,416.21c-5.34-4.38-9-11.83-8.32-18.8.04-.32.34-.55.66-.5,5.7,3.68,9,12.27,8.58,18.9-.03.44-.57.67-.91.4h-.01Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -275.96,
    y1: 416.8,
    x2: -296.59,
    y2: 400.64,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-276.27,417.2c-8.92-.77-18.14-7.37-20.63-16.17-.09-.34.11-.68.45-.77,9.14.12,17.94,7.68,20.8,16.15.13.4-.2.82-.62.79h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -274.6,
    y1: 416.48,
    x2: -272.14,
    y2: 389.84,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-275.1,416.43c-3.53-8.12-2.92-19.42,2.46-26.63.2-.26.58-.3.84-.1,4.25,7.76,2.61,19.67-2.3,26.83-.25.35-.82.3-1-.09h0Z",
    fill: "#7db5a9"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M221.58,36.85c5.51-1.96,5.39-20.28-6.58-29.55-1.04-.8-2.52-.23-3.54.59-6.72,5.47-8.62,19.93-5.35,29.16",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 215.6,
    y1: 46.36,
    x2: 214.63,
    y2: 25.47,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.1,46.39c-3.4-6.13-4.12-14.51-.97-20.89.15-.28.51-.39.79-.24,4,5.6,3.96,14.93,1.18,21.08-.18.4-.78.42-1,.05h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 215.19,
    y1: 47.07,
    x2: 201.6,
    y2: 24.17,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.76,47.33c-8.11-4.07-14.39-13.68-13.59-22.91.04-.34.35-.59.69-.55,8.53,3.5,14.11,13.94,13.76,22.95-.02.42-.49.69-.86.51h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 216.59,
    y1: 47.27,
    x2: 228.71,
    y2: 22.91,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.15,47.04c-.3-8.95,4.45-19.47,12.11-24.36.28-.17.64-.08.81.2,1.13,8.85-4.83,19.61-12.03,24.6-.36.24-.88-.02-.9-.45h.01Z",
    fill: "#7db5a9"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-180.4,209.15c5.51-1.96,5.39-20.28-6.58-29.55-1.04-.8-2.52-.23-3.54.59-6.72,5.47-8.62,19.93-5.35,29.16",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -186.37,
    y1: 218.67,
    x2: -187.34,
    y2: 197.78,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.87,218.7c-3.4-6.13-4.12-14.51-.97-20.89.15-.28.51-.39.79-.24,4,5.6,3.96,14.93,1.18,21.08-.18.4-.78.42-1,.05h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -186.79,
    y1: 219.38,
    x2: -200.38,
    y2: 196.47,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-187.22,219.64c-8.11-4.07-14.39-13.68-13.59-22.91.04-.34.35-.59.69-.55,8.53,3.5,14.11,13.94,13.76,22.95-.02.42-.49.69-.86.51h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -185.38,
    y1: 219.57,
    x2: -173.27,
    y2: 195.22,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-185.83,219.35c-.3-8.95,4.45-19.47,12.11-24.36.28-.17.64-.08.81.2,1.13,8.85-4.83,19.61-12.03,24.6-.36.24-.88-.02-.9-.45h.01Z",
    fill: "#7db5a9"
  })))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M-1069.56,682.63c49.56-19.78,83.78-67.78,92.44-111.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower4);
export default __webpack_public_path__ + "static/media/flower4.51630d807446f74cb63fa928a3867d8b.svg";
export { ForwardRef as ReactComponent };